import {createContext, useContext, useEffect, useReducer, useRef, useState} from 'react';
import {TokenContext} from "./TokenContext";
import {Dialog, DialogTitle} from "@mui/material";

const WebSocketContext = createContext(null)
//                                                                         ready, value, send
// Make sure to put WebsocketProvider higher up in
// the component tree than any consumer.
// let ws = null

function WebSocketProvider({children}) {

    // const [ws, setWs] = useState(null);
    const [lastMsg, setLastMsg] = useState(null);
    const [lastMsgSend, setLastMsgSend] = useState('');
    const [wsIsConnected, setWsIsConnected] = useState(false);
    const [disconnected, setDisconnected] = useState(false);
    const channels = useRef({})
    const [retryAccessToken, setRetryAccessToken] = useState(3);
    const [ws, setWs] = useState(null);
    const { accessToken } = useContext(TokenContext);




    const send = (msgObject, callback) => {
        //create unique Id
        let uniqueId = msgObject.path + "_";
        uniqueId += Date.now() + "_";
        uniqueId += Math.random();
        msgObject["id"] = uniqueId;

        subscribe(msgObject.id, callback)
        ws.send(JSON.stringify(msgObject))

        return uniqueId
    }

    const subscribe = (id, callback) => {
        channels.current[id] = callback
    }

    /* remove callback  */
    const unsubscribe = (id) => {
        delete channels.current[id]
    }

    useEffect(() => {

        if (!wsIsConnected && accessToken) {
            try {
                const secure =  process.env.NODE_ENV === 'development'?'ws' : 'wss'
                const websocket = new WebSocket(process.env.REACT_APP_SERVER_URL_WS)
                setWs(websocket)
                // ws = (new WebSocket("ws://192.168.214.221:8082"))
            } catch (e) {

            }
        }
    }, [accessToken, retryAccessToken])



    const authentication = ()=>{
        console.log('🔐 [WebSocket] Authenticating WebSocket connection...');
        console.log('📋 [WebSocket] Token utilisé:', accessToken ? accessToken.substring(0, 20) + '...' : 'AUCUN TOKEN');
        console.log('⏰ [WebSocket] Timestamp:', new Date().toISOString());

        send({
            type:'auth',
            token:accessToken
        }, (msg)=>{
            console.log('📨 [WebSocket] Authentication response:', msg);
            if(msg.hasOwnProperty('code_execution') && msg.code_execution === 'AUTHORIZE'){
                console.log('✅ [WebSocket] Authentication successful');
                setWsIsConnected(true)
            } else if(msg.hasOwnProperty('code_execution') && msg.code_execution === 'UNAUTHORIZED') {
                console.error('❌ [WebSocket] Authentication failed - token invalid');
                setWsIsConnected(false)
                // Ne pas fermer la WebSocket, juste marquer comme non connecté
            } else {
                console.warn('⚠️ [WebSocket] Unexpected authentication response:', msg);
            }
        })
    }

    useEffect(() => {
        if (ws !== null) {

            ws.onopen = () => {
                authentication()
            };
            ws.onclose = async (e) => {
                console.log('🔌 WebSocket connection closed', { code: e.code, reason: e.reason, wasClean: e.wasClean });
                setWsIsConnected(false)
                
                if(accessToken){
                    const retry = retryAccessToken - 1
                    console.log('🔄 WebSocket retry count:', retry);
                    
                    // 🛑 CIRCUIT BREAKER: Ne pas spammer les refresh tokens
                    if (retry <= 0) {
                        console.log('❌ WebSocket max retries reached, stopping connection attempts');
                        setWs(null)
                        setDisconnected(true)
                        // Ne PAS déconnecter automatiquement, juste arrêter les tentatives WebSocket
                        // _tokenContext.disconnect()
                        return;
                    }

                    // Délai plus long entre les tentatives pour éviter le spam
                    console.log('⏳ WebSocket waiting 5 seconds before retry');
                    setTimeout(() => {
                        setRetryAccessToken(retry)
                    }, 5000) // Augmenté de 1s à 5s
                } else {
                    console.log('🚫 No access token, stopping WebSocket reconnection attempts');
                }
            };

            ws.onmessage = (msgString) => {
                const msg = JSON.parse(msgString.data)
                if (channels.current[msg.id]) {
                    channels.current[msg.id](msg)
                } else {
                    channels.current[msg.id]?.(msg)
                }
            }

            ws.onerror = (error) => {
                setWsIsConnected(false)
                console.error('WebSocket error:', error);
            }
        }
    }, [ws])

    function wsSend(msg) {

        if (ws !== null && lastMsgSend !== msg) {
            setLastMsgSend(msg)
            ws.send(msg)
        }
    }

    function checkInactivity() {
        let lastActiveTime = Date.now();

        setInterval(() => {
            const currentTime = Date.now();
            const elapsedTime = currentTime - lastActiveTime;

            if (elapsedTime > 10 * 60 * 1000) { // 10 minutes in milliseconds
                ws.close()
                ws.terminate()
                setWsIsConnected(false)
            }
        }, 1000); // Check every second
    }


    // async function lastMsg() {
    //     let msg = ''
    //     if (ws !== null && wsIsConnected) {
    //         console.log(ws.onmessage)
    //     }
    //     console.log(msg)
    //     return msg
    // }

    return (
        <WebSocketContext.Provider
            value={{ws, lastMsg, setLastMsg, subscribe, wsIsConnected, send, unsubscribe,disconnected }}>

            {children}
        </WebSocketContext.Provider>
    );
};

export {WebSocketContext, WebSocketProvider};
